var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnCloseBlackBold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_38626",
    "data-name": "\\uADF8\\uB8F9 38626",
    transform: "translate(-55.072 -37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close",
    "data-name": "Icon ionic-md-close",
    className: "cls-1",
    d: "M28.523,9.623l-2.1-2.1-8.4,8.4-8.4-8.4-2.1,2.1,8.4,8.4-8.4,8.4,2.1,2.1,8.4-8.4,8.4,8.4,2.1-2.1-8.4-8.4Z",
    transform: "translate(47.549 29.477)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCloseBlackBold);
export default __webpack_public_path__ + "static/media/btn-close-black-bold.5252bcaf1fce73727d48a91e0636843f.svg";
export { ForwardRef as ReactComponent };